import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { VictoryView } from "./views/VictoryView";
import { VictorySceneResult } from "./VictorySceneResult";
import { LocalizationModel } from "../../../common/models/LocalizationModel";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { VictoryResourcesPackage } from "./resources/VictoryResourcesPackage";
import { PlayerModel } from "../../../common/models/PlayerModel";
import { VictorySceneOptions } from "./VictorySceneOptions";
import { VictoryPopupController } from "./controllers/VictoryPopupController";
import { AudioController } from "../../game/components/AudioController";
import { SpineResourcesPackage } from "../../../common/resources/SpineResourcesPackage";
import { BoostersConfiguration } from "../../../common/models/BoostersConfiguration";

@injectable()
export class VictoryScene extends Viewable<VictorySceneResult> {
    public constructor(
        commonResources: CommonResourcesPackage,
        spineResources: SpineResourcesPackage,
        victoryResources: VictoryResourcesPackage,
        localizationModel: LocalizationModel,
        playerModel: PlayerModel,
        boostersConfiguration: BoostersConfiguration,
        victoryController: VictoryPopupController,
        audioController: AudioController,
        @inject(InjectableInterfaces.VictorySceneOptions)
        options: VictorySceneOptions,
        @inject(InjectableInterfaces.ICanvasScaler)
        canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<VictorySceneResult>();
        this.view = new VictoryView(
            commonResources,
            spineResources,
            victoryResources,
            localizationModel,
            playerModel,
            boostersConfiguration,
            victoryController,
            audioController,
            options.coinsReward,
            options.savedVegetables,
            options.totalVegetables,
            canvasScaler, 
            pcs
        );
        pcs.result.then(
            (result: VictorySceneResult) => this.operationControls.complete(result),
            (reason: unknown) => this.operationControls.error(reason)
        );
    }
}
